import { useFeatures } from '../../../../hooks';

const GENERIC_COMPOSITE_REPORT_FEATURE = 'genericCompositeReport';

/**
 * CR-11: Returns true when the genericCompositeReport PHC feature flag is on.
 * Gate rendering and invocations behind this hook so the module is invisible
 * in environments where the flag is off (production default: false).
 */
export const useIsCompositeReportEnabled = (): boolean =>
  useFeatures()(GENERIC_COMPOSITE_REPORT_FEATURE);
